/**
 * Represents a task loop that executes a provided task at a specified interval.
 */
class TaskLoop {
  /**
   * The task function to be executed in the loop.
   */
  task: () => any;

  /**
   * Reference to the interval timer used for the task loop.
   */
  private intervalRef: number | null = null;

  /**
   * The interval duration (in milliseconds) between task executions.
   */
  public interval: number;

  /**
   * Constructs a new TaskLoop object.
   * @param task - The task function to be executed in the loop.
   * @param interval - The interval duration (in milliseconds) between task executions.
   */
  constructor(task: () => any, interval: number) {
    this.task = task;
    this.interval = interval;
  }

  /**
   * Starts the task loop.
   * If the loop is already running, it does nothing.
   */
  start() {
    if (this.intervalRef !== null) {
      // already running
      return;
    }
    this.intervalRef = window.setInterval(this.task, this.interval);
  }

  /**
   * Stops the task loop.
   * If the loop is not running, it does nothing.
   */
  stop() {
    if (this.intervalRef !== null) {
      window.clearInterval(this.intervalRef);
    }
    this.intervalRef = null;
  }
}

export default TaskLoop;
